import { createElement } from "react";
import { RouteObject } from "react-router-dom";
import { routes } from "@shared/lib/react-router";
import { ProjectDocstore } from "./ui";

export function ProjectDocstoreRoute(...rest: RouteObject[]): RouteObject {
  return {
    path: routes.project.docstore(),
    element: createElement(ProjectDocstore),
    children: rest,
  };
}
